module.exports = __webpack_public_path__ + "static/img_main_event_iam2-e10e8607c615c117151f2a1276a8b11d.png";